"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.api = exports.FetchMethod = void 0;
const lodash_1 = require("lodash");
const js_cookie_1 = __importDefault(require("js-cookie"));
const core_1 = require("@sierralabs/core");
var FetchMethod;
(function (FetchMethod) {
    FetchMethod["Get"] = "GET";
    FetchMethod["Patch"] = "PATCH";
    FetchMethod["Post"] = "POST";
    FetchMethod["Put"] = "PUT";
    FetchMethod["Delete"] = "DELETE";
})(FetchMethod = exports.FetchMethod || (exports.FetchMethod = {}));
exports.api = {
    environment: {},
    setEnvironment: (environment) => {
        exports.api.environment = environment;
    },
    getEntity: (key, defaultValue) => {
        var _a;
        const value = ((_a = exports.api.environment.entities) === null || _a === void 0 ? void 0 : _a[key]) || defaultValue;
        return {
            name: value,
            tableName: (0, core_1.tableCase)(value),
            displayName: (0, lodash_1.startCase)(value),
            propertyName: (0, lodash_1.camelCase)(value)
        };
    },
    getBaseUrl: () => exports.api.environment.apiBaseUrl,
    getAccessToken: () => {
        return js_cookie_1.default.get(exports.api.environment.accessTokenKey);
    },
    setAccessToken: (token) => {
        js_cookie_1.default.set(exports.api.environment.accessTokenKey, token, {
            expires: exports.api.environment.expires || 365,
            domain: exports.api.environment.domain || window.location.hostname,
            secure: exports.api.environment.secure || false
        });
    },
    removeAccessToken: () => js_cookie_1.default.remove(exports.api.environment.accessTokenKey, {
        domain: exports.api.environment.domain || window.location.hostname
    }),
    get: (path, queryParams) => {
        return exports.api.fetch(FetchMethod.Get, path, queryParams);
    },
    delete: (path, queryParams) => {
        return exports.api.fetch(FetchMethod.Delete, path, queryParams);
    },
    patch: (path, body) => {
        return exports.api.fetch(FetchMethod.Patch, path, body);
    },
    post: (path, body) => {
        return exports.api.fetch(FetchMethod.Post, path, body);
    },
    put: (path, body) => {
        return exports.api.fetch(FetchMethod.Put, path, body);
    },
    fetch: (method, path, params = {}) => {
        const controller = new AbortController();
        const { signal } = controller; // allow aborting the fetch call
        if (!exports.api.environment.apiBaseUrl) {
            throw new Error('`api.environment` not setup properly. Missing `apiBaseUrl`.');
        }
        const url = new URL(path, exports.api.environment.apiBaseUrl);
        // console.log('url', url);
        // only add authorization header if token exists to avoid "Bearer undefined"
        const headers = {};
        const token = exports.api.getAccessToken();
        if (token) {
            headers[exports.api.environment.accessTokenKey] = `Bearer ${token}`;
        }
        if (exports.api.environment.headers) {
            Object.assign(headers, exports.api.environment.headers);
        }
        const options = {
            headers,
            method,
            signal
        };
        switch (method) {
            case FetchMethod.Get:
            case FetchMethod.Delete:
                Object.entries(params).forEach(([key, value]) => {
                    url.searchParams.set(key, typeof value === 'object' ? JSON.stringify(value) : value);
                });
                break;
            case FetchMethod.Patch:
            case FetchMethod.Post:
            case FetchMethod.Put:
                options.headers['content-type'] = 'application/json';
                options.body = JSON.stringify(params);
                break;
        }
        return {
            response: fetch(url.toString(), options),
            abort: controller.abort.bind(controller)
        };
    }
};
exports.default = exports.api;
//# sourceMappingURL=api.js.map